<template>
  <div class="mc-wrapper">
    <div class="mc-container">
      <div class="mc-personal">
        <div v-if="formSubmitted && !hasErrors" class="mc-form__message mc-form__message--success"> Данные сохранены. </div>
        <div v-if="serverError" class="mc-form__message mc-form__message--alert">
          {{ serverError }}
        </div>
        <form class="mc-form" id="personalData" @submit.prevent="submitForm" autocomplete="off">
          <div class="mc-form__body">
            <fieldset class="mc-form__fieldset">
              <div class="mc-form__fieldset-title">
                Персональные данные
              </div>
              <div class="mc-form__field" :class="{ isError: errors.surname }">
                <label class="mc-form__label" for="personalDataSurname">
                  Фамилия
                  <span class="mc-form__asterisk">*</span>
                </label>
                <span v-if="errors.surname" class="mc-form__error-text">
                  {{ errors.surname }}
                </span>
                <input class="mc-form__input" id="personalDataSurname" type="text" v-model="formData.surname" name="surname" placeholder="Иванова" >
              </div>
              <div class="mc-form__field" :class="{ isError: errors.name }">
                <label class="mc-form__label" for="personalDataName">
                  Имя
                  <span class="mc-form__asterisk">*</span>
                </label>
                <span v-if="errors.name" class="mc-form__error-text">
                  {{ errors.name }}
                </span>
                <input class="mc-form__input" id="personalDataName" type="text" v-model="formData.name" name="name" placeholder="Елена" required>
              </div>
              <div class="mc-form__field" :class="{ isError: errors.patronymic }">
                <label class="mc-form__label" for="personalDataPatronymic">
                  Отчество
                </label>
                <span v-if="errors.patronymic" class="mc-form__error-text">
                  {{ errors.patronymic }}
                </span>
                <input class="mc-form__input" id="personalDataPatronymic" type="text" v-model="formData.patronymic" name="patronymic" placeholder="Ивановна">
              </div>
              <div class="mc-form__field" :class="{ isError: errors.email }">
                <label class="mc-form__label" for="personalDataEmail">
                  E-mail
                  <span class="mc-form__asterisk">*</span>
                </label>
                <span v-if="errors.email" class="mc-form__error-text">
                  {{ errors.email }}
                </span>
                <input class="mc-form__input" id="personalDataEmail" type="email" v-model="formData.email" name="email" placeholder="example@mail.ru" required>
              </div>
              <div class="mc-form__field" :class="{ isError: errors.phone }">
                <label class="mc-form__label" for="personalDataPhone">
                  Телефон
                  <span class="mc-form__asterisk">*</span>
                </label>
                <span v-if="errors.phone" class="mc-form__error-text">
                  {{ errors.phone }}
                </span>
                  <input class="mc-form__input" id="personalDataPhone" :name="formData.phone" :value="formData.phone" readonly />
              </div>
              <div class="mc-form__field" :class="{ isError: errors.birthdate }">
                <label class="mc-form__label">
                  Дата рождения
                  <span class="mc-form__asterisk">*</span>
                </label>
                <span v-if="errors.birthdate" class="mc-form__error-text">
                  {{ errors.birthdate }}
                </span>
                <div class="mc-form__date mc-date">
                  <template v-if="user.birthday">
                    <div class="mc-date__field">
                      <input :value="formData.day" class="mc-form__input" readonly />
                    </div>
                    <div class="mc-date__middle">
                      <button class="mc-date__select-button js-modal-button" data-target="personalDataBirthdayMonth" disabled type="button">
                        {{ selectedMonth }}
                      </button>
                    </div>
                    <div class="mc-date__field">
                      <input :value="formData.year" class="mc-form__input" readonly />
                    </div>
                  </template>
                  <template v-else>
                    <div class="mc-date__field">
                      <MaskInput class="mc-form__input" id="personalDataBirthdayDay" v-model="formData.day" :value="formData.day" mask="##" placeholder="__" required />
                    </div>
                    <div class="mc-date__middle">
                      <button @click="isMonthModalOpen = true" class="mc-date__select-button js-modal-button" data-target="personalDataBirthdayMonth"  type="button">
                        {{ selectedMonth }}
                      </button>
                      <div class="mc-modal" :class="{ isOpen: isMonthModalOpen }" id="personalDataBirthdayMonth">
                        <div class="mc-modal__outer">
                          <div class="mc-modal__inner">
                            <div class="mc-modal__heading">
                              <button @click="isMonthModalOpen = false" class="mc-modal__close-button js-button-close simulated-hover" type="button" aria-label="Закрыть">
                                <svg class="mc-modal__close-icon" width="30" height="30" viewBox="0 0 30 30">
                                  <use xlink:href="/assets/svg/sprite.svg#icon-cross"></use>
                                </svg>
                              </button>
                              <div class="mc-modal__title">
                                Месяц
                              </div>
                            </div>
                            <div class="mc-modal__body">
                              <ul class="mc-filter__option-list mc-options">
                                <li v-for="(month, index) in months" :key="index" class="mc-options__item">
                                  <button
                                      class="mc-options__button"
                                      :class="{ isSelected: selectedMonth === month }"
                                      type="button"
                                      @click="selectMonth(month, index+1)">
                                    {{ month }}
                                  </button>
                                </li>
                              </ul>
                            </div>
                            <div class="mc-modal__bottom">
                              <button @click="isMonthModalOpen = false" class="mc-button mc-button--color js-button-close" type="button">
                              <span class="mc-button__text">
                                Закрыть
                              </span>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="mc-date__field">
                      <MaskInput :value="formData.year" class="mc-form__input" id="personalDataBirthdayYear" v-model="formData.year" mask="####" placeholder="____" required />
                    </div>
                  </template>

                </div>
                <p class="mc-form__notice">
                  Установить дату рождения в личном кабинете можно только один раз. Для изменения даты рождения - обратитесь к администратору сайта&nbsp;<a href="#">info@mcbuy.ru</a>.
                </p>
              </div>
            </fieldset>
            <fieldset class="mc-form__fieldset">
              <div class="mc-form__fieldset-title">
                Смена пароля
              </div>
              <div class="mc-form__field" :class="{ isError: errors.password }">
                <label class="mc-form__label" for="personalDataPassword">
                  Новый пароль
                </label>
                <span v-if="errors.password" class="mc-form__error-text">
                  {{ errors.password }}
                </span>
                <input class="mc-form__input" id="personalDataPassword" type="password" v-model="formData.password" name="password" autocomplete="new-password">
              </div>
              <div class="mc-form__field" :class="{ isError: errors.passwordRepeat }">
                <label class="mc-form__label" for="personalDataPasswordRepeat">
                  Повторите новый пароль
                </label>
                <span v-if="errors.passwordRepeat" class="mc-form__error-text">
                  {{ errors.passwordRepeat }}
                </span>
                <input class="mc-form__input" id="personalDataPasswordRepeat" type="password" v-model="formData.passwordRepeat" name="passwordRepeat" autocomplete="new-password">
              </div>
            </fieldset>
            <button class="mc-button mc-button--color" type="submit" :disabled="isSubmitting">
              {{ isSubmitting ? 'Сохранение...' : 'Сохранить' }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { MaskInput } from 'vue-3-mask';

export default {
  data() {
    return {
      formData: {
        surname: '',
        name: '',
        patronymic: '',
        email: '',
        phone: '',
        day: '',
        month: 1, // Default to September (index 9)
        year: '',
        password: '',
        passwordRepeat: ''
      },
      isMonthModalOpen: false,
      selectedMonth: 'Январь',
      months: [
        'Январь', 'Февраль', 'Март', 'Апрель',
        'Май', 'Июнь', 'Июль', 'Август',
        'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'
      ],
      errors: {},
      serverError: null,
      formSubmitted: false,
      isSubmitting: false
    }
  },
  components: {
    MaskInput
  },
  computed: {
    hasErrors() {
      return Object.keys(this.errors).length > 0;
    },
    user() {
      return this.$store.getters.user;
    }
  },
  async created() {
    console.log(this.user);
    this.formData.name = this.user.name;
    this.formData.surname = this.user.last_name;
    this.formData.patronymic = this.user.second_name;
    this.formData.email = this.user.email;
    this.formData.phone = this.user.phone;
    if (this.user.birthday) {
      this.formData.day = this.user.day;
      this.formData.month = this.user.month;
      this.formData.year = this.user.year;
      this.selectedMonth = this.months[this.formData.month - 1];
    }
  },
  mounted() {
    // You can fetch user data here if needed
  },
  methods: {
    formatPhoneNumber() {
      // Manual formatting of phone number
      let phone = this.formData.phone.replace(/\D/g, '');

      if (phone.length > 0) {
        if (phone[0] !== '7' && phone[0] !== '8') {
          phone = '7' + phone;
        } else if (phone[0] === '8') {
          phone = '7' + phone.substring(1);
        }
      }

      let formattedPhone = '';

      if (phone.length > 0) {
        formattedPhone = '+' + phone[0];
      }

      if (phone.length > 1) {
        formattedPhone += ' (' + phone.substring(1, 4);
      }

      if (phone.length > 4) {
        formattedPhone += ') ' + phone.substring(4, 7);
      }

      if (phone.length > 7) {
        formattedPhone += '-' + phone.substring(7, 9);
      }

      if (phone.length > 9) {
        formattedPhone += '-' + phone.substring(9, 11);
      }
      this.formData.phone = formattedPhone;
    },

    selectMonth(month, monthIndex) {
      this.selectedMonth = month;
      this.formData.month = monthIndex;
      // Close modal (assuming you have JS that toggles modal visibility)
      const closeButtons = document.querySelectorAll('.js-button-close');
      if (closeButtons.length) {
        closeButtons[0].click();
      }
    },

    scrollToFirstError() {
        this.$nextTick(() => {
        // Find first error element or server error message
        const firstErrorElement = this.serverError
          ? document.querySelector('.mc-form__message--alert')
          : document.querySelector('.isError');

        if (firstErrorElement) {
          // Scroll to the element with smooth behavior
          firstErrorElement.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
        });
        }
      });
  },

    validateForm() {
      this.errors = {};

      // Validate surname
      if (!this.formData.surname.trim()) {
        this.errors.surname = 'Фамилия обязательна';
      } else if (this.formData.surname.length < 2) {
        this.errors.surname = 'Фамилия должна содержать минимум 2 символа';
}

      // Validate name
      if (!this.formData.name.trim()) {
        this.errors.name = 'Имя обязательно';
      } else if (this.formData.name.length < 2) {
        this.errors.name = 'Имя должно содержать минимум 2 символа';
      }

      // Validate email
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!this.formData.email.trim()) {
        this.errors.email = 'Email обязателен';
      } else if (!emailRegex.test(this.formData.email)) {
        this.errors.email = 'Некорректный формат email';
      }

      // Validate phone - with mask we can simplify the validation
      if (!this.formData.phone) {
        this.errors.phone = 'Телефон обязателен';
      } else if (this.formData.phone.includes('_')) {
        this.errors.phone = 'Телефон заполнен не полностью';
      }

      // Validate birth date
      const day = parseInt(this.formData.day);
      const year = parseInt(this.formData.year);

      if (!day || !year) {
        this.errors.birthdate = 'Дата рождения обязательна';
      } else if (day < 1 || day > 31) {
        this.errors.birthdate = 'Некорректный день';
      } else if (year < 1900 || year > new Date().getFullYear()) {
        this.errors.birthdate = 'Некорректный год';
      }

      // Validate password fields
      if (this.formData.password && this.formData.password.length < 6) {
        this.errors.password = 'Пароль должен содержать минимум 6 символов';
      }

      if (this.formData.password !== this.formData.passwordRepeat && this.formData.password) {
        this.errors.passwordRepeat = 'Пароли не совпадают';
      }

      const isValid = Object.keys(this.errors).length === 0;

      if (!isValid) {
        this.scrollToFirstError();
      }

      return isValid;
    },

    async submitForm() {
      if (!this.validateForm()) {
        return;
      }

      this.isSubmitting = true;
      this.serverError = null;

      try {
        // Prepare data for submission
        const formDataToSubmit = {
          ...this.formData,
          birthdate: `${this.formData.year}-${this.formData.month}-${this.formData.day}`
        };

        // Remove the individual date fields that we merged
        delete formDataToSubmit.day;
        delete formDataToSubmit.month;
        delete formDataToSubmit.year;

        // Don't send empty password fields
        if (!formDataToSubmit.password) {
          delete formDataToSubmit.password;
          delete formDataToSubmit.passwordRepeat;
        } else {
          // We don't need to send the password confirmation to the server
          delete formDataToSubmit.passwordRepeat;
        }

        const response = await axios.post('/api/user/profile/', formDataToSubmit,
            {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            });
        if (response.data.status == 'error') {
          this.serverError= '';
          for (let i in response.data.errors) {
            console.log(typeof response.data.errors[i].code)
            if (typeof response.data.errors[i].code != 'number' && response.data.errors[i].code!= 'cert')
              this.errors[response.data.errors[i].code] = response.data.errors[i].message;
            else
              this.serverError += response.data.errors[i].message+"<br>";
          }
          throw new Error(response.data.errors);
        }

        this.formSubmitted = true;
        this.$store.dispatch('Auth', response.data.data)
        // Scroll to the success message
        this.$nextTick(() => {
          const successMessage = document.querySelector('.mc-form__message--success');
          if (successMessage) {
            successMessage.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        });

      } catch (error) {
        let errorMessage = 'Произошла техническая ошибка. Попробуйте еще раз.';

       /* if (error.response && error.response.data) {
          // Handle axios error responses
          errorMessage = error.response.data.message || errorMessage;
        } else if (error.message) {
          // Use the thrown error message
          errorMessage = error.message;
      }*/
        if (!this.serverError)
          this.serverError = errorMessage;
        this.scrollToFirstError();
      } finally {
        this.isSubmitting = false;
    }
}
  },
}
</script>
